(() => {
  const KLAVIYO_COMPANY_ID = 'Rjrd2T';
  const KLAVIYO_REVISION = '2026-07-15';
  const RSVP_HASH = '#bear-sinister-rsvp';
  let rsvpScrollFrame = 0;
  let removeRsvpScrollCancelListeners = () => {};

  const easeInOutCubic = (progress) => (
    progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2
  );

  const scrollToRsvp = (target) => {
    cancelAnimationFrame(rsvpScrollFrame);
    removeRsvpScrollCancelListeners();

    const stickyHeader = document.querySelector('.header__outer-wrapper');
    const headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
    const startY = window.scrollY;
    const targetY = Math.max(0, startY + target.getBoundingClientRect().top - headerOffset - 20);
    const distance = targetY - startY;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || Math.abs(distance) < 4) {
      window.scrollTo(0, targetY);
      return;
    }

    const duration = Math.min(2200, Math.max(800, Math.abs(distance) * 0.28));
    const startedAt = performance.now();
    const cancelEvents = ['wheel', 'touchstart', 'keydown'];

    const cleanup = () => {
      cancelEvents.forEach((eventName) => {
        window.removeEventListener(eventName, cancelScroll);
      });
      removeRsvpScrollCancelListeners = () => {};
    };

    const cancelScroll = () => {
      cancelAnimationFrame(rsvpScrollFrame);
      cleanup();
    };

    removeRsvpScrollCancelListeners = cleanup;
    cancelEvents.forEach((eventName) => {
      window.addEventListener(eventName, cancelScroll, { passive: true });
    });

    const step = (now) => {
      const progress = Math.min(1, (now - startedAt) / duration);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));

      if (progress < 1) {
        rsvpScrollFrame = requestAnimationFrame(step);
      } else {
        cleanup();
      }
    };

    rsvpScrollFrame = requestAnimationFrame(step);
  };

  const initializeRsvpScrollLinks = () => {
    document.querySelectorAll(`a[href="${RSVP_HASH}"]`).forEach((link) => {
      if (link.dataset.bs3ScrollReady === 'true') return;
      link.dataset.bs3ScrollReady = 'true';

      link.addEventListener('click', (event) => {
        const target = document.querySelector(RSVP_HASH);
        if (!target) return;

        event.preventDefault();
        if (window.location.hash !== RSVP_HASH) {
          window.history.pushState(null, '', RSVP_HASH);
        }
        scrollToRsvp(target);
      });
    });
  };


  const normalizeUsPhone = (value) => {
    const raw = value.trim();
    if (raw.startsWith('+')) return `+${raw.slice(1).replace(/\D/g, '')}`;
    const digits = raw.replace(/\D/g, '');
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
    return '';
  };

  const subscribe = async ({ listId, email, phone, includeSms, source }) => {
    const subscriptions = {
      email: { marketing: { consent: 'SUBSCRIBED' } }
    };

    if (includeSms) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };

    const attributes = {
      email,
      properties: {
        event_name: 'Bear Sinister 3',
        event_date: '2026-10-10',
        event_interest: true,
        rsvp_source: source
      },
      subscriptions
    };

    if (includeSms) attributes.phone_number = phone;

    const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes } }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    });

    if (!response.ok) throw new Error('subscription_failed');
  };

  const initialize = (form) => {
    if (form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    const smsChoice = form.querySelector('[name="sms"]');
    const smsFields = form.querySelector('[data-bs3-sms-fields]');
    const phoneInput = form.querySelector('[name="phone"]');
    const submitButton = form.querySelector('[data-bs3-submit]');
    const errorMessage = form.querySelector('[data-bs3-error]');
    const successMessage = form.querySelector('[data-bs3-success]');

    const syncSmsFields = () => {
      smsFields.classList.toggle('is-active', smsChoice.checked);
      smsFields.setAttribute('aria-hidden', String(!smsChoice.checked));
      smsChoice.setAttribute('aria-expanded', String(smsChoice.checked));
      phoneInput.required = smsChoice.checked;
    };

    smsChoice.addEventListener('change', syncSmsFields);
    syncSmsFields();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      errorMessage.hidden = true;

      const emailInput = form.querySelector('[name="email"]');
      const newsletterChoice = form.querySelector('[name="newsletter"]');
      const email = emailInput.value.trim();
      const includeSms = smsChoice.checked;
      const phone = includeSms ? normalizeUsPhone(phoneInput.value) : '';

      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (includeSms && !phone) {
        errorMessage.textContent = 'Enter a valid US mobile number for text updates.';
        errorMessage.hidden = false;
        phoneInput.focus();
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'ADDING YOU...';

      try {
        await subscribe({
          listId: form.dataset.eventList,
          email,
          phone,
          includeSms,
          source: 'Bear Sinister 3 RSVP'
        });

        if (newsletterChoice.checked) {
          await subscribe({
            listId: form.dataset.newsletterList,
            email,
            phone: '',
            includeSms: false,
            source: 'Bear Sinister 3 RSVP Brand Opt-In'
          });
        }

        Array.from(form.children).forEach((child) => {
          if (child !== successMessage) child.hidden = true;
        });
        successMessage.hidden = false;
        successMessage.focus();
      } catch (error) {
        errorMessage.textContent = 'Something went wrong. Please try again.';
        errorMessage.hidden = false;
        submitButton.disabled = false;
        submitButton.textContent = 'RSVP + ENTER TO WIN';
      }
    });
  };

  const boot = () => {
    initializeRsvpScrollLinks();
    document.querySelectorAll('[data-bs3-rsvp]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
